module.exports = __webpack_public_path__ + "img/product-wrap-bg-selected.2755f47b.png";